import DOMPurify from 'dompurify'

export const sanitizedHtml = (el, binding) => {
  el.innerHTML = DOMPurify.sanitize(binding.value)
}
